import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 ${({ theme }) => theme.spacing.ms} ${({ theme }) => theme.spacing.md};
`;

export const CalendarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const CalendarTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`;

export const CalendarNavButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  outline: none;

  /* ホバー状態 */
  &:hover {
    background-color: ${({ theme }) => theme.colors.border.light};
  }

  /* フォーカス状態（キーボードナビゲーション用） */
  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
    background-color: ${({ theme }) => theme.colors.border.light};
  }

  /* アクティブ状態 */
  &:active {
    transform: scale(0.95);
  }

  /* 無効状態 */
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  outline: solid 1px ${({ theme }) => theme.colors.border.light};
  box-shadow: ${({ theme }) => theme.shadows.md};
  overflow: hidden;
`;

export const CalendarDayHeader = styled.div<{ $dayIndex?: number }>`
  text-align: center;
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ $dayIndex, theme }) =>
    $dayIndex === 0 ? theme.colors.text.sunday :  // 日曜日
    $dayIndex === 6 ? theme.colors.text.saturday :  // 土曜日
    theme.colors.text.secondary};
  padding: ${({ theme }) => theme.spacing.xs} 0;
  outline: 1px solid ${({ theme }) => theme.colors.border.light};
`;
